// extracted by mini-css-extract-plugin
module.exports = {"fallbackContainer":"Fallback_fallbackContainer__2aknT","fadeout":"Fallback_fadeout__1IIqO","fallbackContainerImage":"Fallback_fallbackContainerImage__2wHql"};